import { lazy } from 'react'
const AddNotifications = lazy(() =>
  import('../../views/admin/AddNotifications')
)
const AdminDashboard = lazy(() => import('../../views/admin/AdminDashboard'))
const Orders = lazy(() => import('../../views/admin/Orders'))
const Category = lazy(() => import('../../views/admin/Category'))
const SubCategory = lazy(() => import('../../views/admin/SubCategory'))
const ProductProperty = lazy(() => import('../../views/admin/ProductProperty'))
const ProductColors = lazy(() => import('../../views/admin/ProductColors'))
const AddProduct = lazy(() => import('../../views/admin/AddProduct'))
const Products = lazy(() => import('../../views/admin/Products'))
const DiscountProducts = lazy(() =>
  import('../../views/admin/DiscountProducts')
)
const EditProduct = lazy(() => import('../../views/admin/EditProduct'))
const AddBanner = lazy(() => import('../../views/admin/AddBanner'))
const Reklam = lazy(() => import('../../views/admin/Reklam'))
// const AddSeller = lazy(() => import('../../views/admin/AddSeller'))
const EditShop = lazy(() => import('../../views/admin/EditShop'))
const AddUser = lazy(() => import('../../views/admin/AddUser'))
const Customers = lazy(() => import('../../views/admin/Customers'))
const Shops = lazy(() => import('../../views/admin/Shops'))
const PaymentRequest = lazy(() => import('../../views/admin/PaymentRequest'))
const DeactiveSellers = lazy(() => import('../../views/admin/DeactiveSellers'))
const UserRequest = lazy(() => import('../../views/admin/UserRequest'))
const UserDetails = lazy(() => import('../../views/admin/UserDetails'))
const ChatSeller = lazy(() => import('../../views/admin/ChatSeller'))
const OrderDetails = lazy(() => import('../../views/admin/OrderDetails'))
const AddCoupon = lazy(() => import('../../views/admin/AddCoupon'))

export const adminRoutes = [
  {
    path: 'admin/dashboard',
    element: <AdminDashboard />,
    role: 'admin',
  },
  {
    path: 'admin/orders',
    element: <Orders />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/subcategory',
    element: <SubCategory />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/add-product',
    element: <AddProduct />,
    role: 'admin',
  },
  {
    path: '/admin/dashboard/products',
    element: <Products />,
    role: 'admin',
  },
  {
    path: '/admin/dashboard/discount-product',
    element: <DiscountProducts />,
    role: 'admin',
  },
  {
    path: '/admin/dashboard/edit-product/:productId',
    element: <EditProduct />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/edit-shop/:sellerId',
    element: <EditShop />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/shops',
    element: <Shops />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/category',
    element: <Category />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/colors',
    element: <ProductColors />,
    role: 'admin',
  },

  {
    path: 'admin/dashboard/product-properties',
    element: <ProductProperty />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/banners',
    element: <AddBanner />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/reklam',
    element: <Reklam />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/payment-request',
    element: <PaymentRequest />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/deactive-sellers',
    element: <DeactiveSellers />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/printhouse',
    element: <UserRequest />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/user/details/:userId',
    element: <UserDetails />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/chat-sellers',
    element: <ChatSeller />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/chat-sellers/:sellerId',
    element: <ChatSeller />,
    role: 'admin',
  },
  {
    path: 'admin/order/details/:orderId',
    element: <OrderDetails />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/users',
    element: <AddUser />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/customers',
    element: <Customers />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/coupon',
    element: <AddCoupon />,
    role: 'admin',
  },
  {
    path: 'admin/dashboard/notifications',
    element: <AddNotifications />,
    role: 'admin',
  },
]
